import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CalendarService } from '../../../../../app/services/calendar.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackCalendar } from '../../../../../app/models/dataPackCalendar.model';

/**
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
@Component({
  selector: 'removeCalendarModal',
  templateUrl: './content.template.html'
})
export class RemoveCalendarModalComponent {

	@Input() calendar: DataPackCalendar;

  private removing: boolean;

  constructor(private activeModal: NgbActiveModal, private calendarService: CalendarService, private alertService: AlertService) {

  }

  private close() {
    this.activeModal.dismiss();
  }

  private remove() {
    this.removing = true;
    let payload: any = {
      calendar: {id: this.calendar.id, description: this.calendar.description}
    };
    this.calendarService.removeCalendar(payload).subscribe(
      data => {
        this.removing = false;
        this.alertService.success(data['result']);
        this.activeModal.close();
      },
      err => {
        this.removing = false;
        this.alertService.error(err.result, err);
        this.activeModal.dismiss();
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/remove/content.component.ts